// Application version - update this when releasing new versions
// This should match the VERSION file in the root directory
export const APP_VERSION = '1.0.0';

// Build metadata (can be populated by CI/CD)
export const BUILD_DATE = '2026-03-20';
